/* file description */

import { useState } from 'react';
import type { UseSetLabel } from './type';

export const useSetLabel: UseSetLabel = () => {
  const [showLabel, setShowLabel] = useState<string>('');
  const [optionList, setOptionList] = useState<any[]>([]);
  return {
    showLabel,
    setShowLabel,
    optionList,
    setOptionList,
  };
};
